__turbopack_context__.v({
  "className": "albert_sans_3e98c3b8-module__tG-iNG__className",
  "variable": "albert_sans_3e98c3b8-module__tG-iNG__variable",
});
